export const CITY_DATA = {
  palotina: { name: 'Palotina', image: '/assets/images/precisa-de-um-site-em-palotina.jpg' },
  maripa: { name: 'Maripá', image: '/assets/images/desenvolvimento-site-personalizado.jpg' },
  'francisco-alves': { name: 'Francisco Alves', image: '/assets/images/desenvolvimento-site-personalizado.jpg' },
  cascavel: { name: 'Cascavel', image: '/assets/images/desenvolvimento-site-personalizado.jpg' },
  toledo: { name: 'Toledo', image: '/assets/images/desenvolvimento-site-personalizado.jpg' },
  'assis-chateaubriand': { name: 'Assis Chateaubriand', image: '/assets/images/desenvolvimento-site-personalizado.jpg' },
  ipora: { name: 'Iporã', image: '/assets/images/desenvolvimento-site-personalizado.jpg' },
  altonia: { name: 'Altônia', image: '/assets/images/desenvolvimento-site-personalizado.jpg' },
  'terra-roxa': { name: 'Terra Roxa', image: '/assets/images/desenvolvimento-site-personalizado.jpg' },
};

export const LOCAL_BUSINESS = {
  name: '(in)nova now',
  legalName: '(in)nova now',
  url: 'https://innovanow.com.br',
  logo: 'https://innovanow.com.br/assets/images/logo.png',
  telephone: '+55-44-99177-5641',
  email: 'contato@innovanow.com.br',
  taxID: '53.817.653/0001-24',
  streetAddress: 'Av. Presidente Kennedy, 2300',
  addressLocality: 'Palotina',
  addressRegion: 'PR',
  postalCode: '85950-000',
  addressCountry: 'BR',
  latitude: -24.2869,
  longitude: -53.8406,
  map: 'https://www.google.com/maps/search/?api=1&query=Av.+Presidente+Kennedy%2C+2300%2C+Palotina%2C+PR%2C+85950-000',
  sameAs: [
    'https://www.instagram.com/innova_now/',
    'https://play.google.com/store/apps/developer?id=innova+now',
    'https://apps.apple.com/br/developer/in-nova-now-tech/id1790867569',
  ],
};

export function getCityData(citySlug) {
  return CITY_DATA[citySlug] || { name: citySlug.replace(/-/g, ' '), image: '/assets/images/desenvolvimento-site-personalizado.jpg' };
}

export function getSystemCanonicalPath(citySlug) {
  return `/desenvolvimento-de-sistema-ou-app-em-${citySlug}`;
}

export function getCityPageMeta(citySlug, variant) {
  const city = getCityData(citySlug);

  if (variant === 'site-criacao' || variant === 'site-desenvolvimento') {
    return {
      title: `Criação de Site em ${city.name} | (in)nova now`,
      description: `Criação de site em ${city.name}-PR: páginas profissionais, responsivas e prontas para o Google. Sede da (in)nova now em Palotina, Av. Presidente Kennedy, 2300.`,
      keywords: `criação de site ${city.name}, desenvolvimento de site ${city.name}, site profissional ${city.name} PR`,
      heroTitle: `Criação de Sites em ${city.name}`,
      heroLead: `Sites sob medida para empresas de ${city.name} e região, feitos pela (in)nova now, com sede em Palotina-PR.`,
      image: variant === 'site-desenvolvimento' && citySlug === 'palotina' ? city.image : '/assets/images/desenvolvimento-site-personalizado.jpg',
      imageAlt: `Criação de site em ${city.name}`,
      ctaLabel: `Criação de site em ${city.name}`,
      canonicalPath: `/criacao-de-site-em-${citySlug}`,
    };
  }

  if (citySlug === 'palotina') {
    return {
      title: 'Desenvolvimento de Sistema em Palotina | Software Sob Medida',
      description:
        'Desenvolvimento de sistema em Palotina-PR: software sob medida, apps Android/iOS e integração com ERP. Sede na Av. Presidente Kennedy, 2300. Orçamento no WhatsApp.',
      keywords:
        'desenvolvimento de sistema palotina, desenvolvimento de sistemas palotina, software sob medida palotina, criação de sistema palotina, aplicativo personalizado palotina, fábrica de software palotina pr',
      heroTitle: 'Desenvolvimento de Sistema em Palotina',
      heroLead:
        'Empresa de Palotina que cria sistemas, aplicativos e automações sob medida — integrados ao seu ERP, com sede na Av. Presidente Kennedy, 2300.',
      canonicalPath: getSystemCanonicalPath('palotina'),
    };
  }

  return {
    title: `Desenvolvimento de Sistema em ${city.name} | Apps e Software Sob Medida`,
    description: `Desenvolvimento de sistemas e aplicativos personalizados em ${city.name}-PR. Software sob medida, apps Android/iOS e integração com ERP pela (in)nova now, de Palotina.`,
    keywords: `desenvolvimento de sistema ${city.name}, desenvolvimento de sistemas ${city.name}, software sob medida ${city.name}, aplicativo personalizado ${city.name}`,
    heroTitle: `Desenvolvimento de Sistema em ${city.name}`,
    heroLead: `Sistemas, aplicativos e automações sob medida para empresas de ${city.name} e região, com sede em Palotina-PR.`,
    canonicalPath: getSystemCanonicalPath(citySlug),
  };
}

export const PALOTINA_SERVICES = [
  {
    title: 'Sistemas web sob medida',
    text: 'Painel administrativo, pedidos, estoque, financeiro, OS, pátio e o fluxo que o ERP de prateleira não cobre na sua operação.',
  },
  {
    title: 'Aplicativos Android e iOS',
    text: 'Apps publicados na Google Play e na App Store: força de vendas, manutenção, holerites, pátio e soluções white label para a sua marca.',
  },
  {
    title: 'Integração com ERP',
    text: 'Conectamos o sistema novo ao ERP que você já usa — clientes, estoque, pedidos e financeiro sem retrabalho e sem planilha paralela.',
  },
  {
    title: 'Automação de processos',
    text: 'CT-e, coletores de dados, check-in em campo e rotinas que hoje dependem de gente copiando informação de um sistema para o outro.',
  },
];

export const PALOTINA_CLIENTS = [
  { name: 'MCL Peças Agrícolas', city: 'Palotina', image: '/assets/images/mcl.webp' },
  { name: 'Demac Peças Agrícolas', city: 'Palotina', image: '/assets/images/demac.png' },
  { name: 'Instituto Inova', city: 'Palotina', image: '/assets/images/inova.png' },
  { name: 'Colégio Terra do Saber', city: 'Palotina', image: '/assets/images/terra.webp' },
];

export const PALOTINA_FAQ = [
  {
    question: 'Vocês desenvolvem sistema em Palotina ou só atendem remoto?',
    answer:
      'A sede da (in)nova now é em Palotina, na Av. Presidente Kennedy, 2300. Atendemos empresas da cidade e da região (Toledo, Cascavel, Maripá, Iporã) presencialmente e projetos em todo o Brasil de forma remota.',
  },
  {
    question: 'Desenvolvimento de sistema em Palotina é só ERP de prateleira?',
    answer:
      'Não. Não vendemos um sistema genérico igual para todo mundo. Mapeamos o processo da sua empresa e construímos o software — sistema web, aplicativo ou os dois — com as regras, telas e integrações que a operação realmente precisa.',
  },
  {
    question: 'Dá para integrar o sistema novo com o ERP que já usamos?',
    answer:
      'Sim. Grande parte dos projetos em Palotina e região nasce exatamente disso: o ERP resolve o fiscal e o estoque, e o sistema sob medida cobre força de vendas, pátio, manutenção, holerites ou o fluxo que ficou na planilha.',
  },
  {
    question: 'Quanto tempo leva para ter a primeira versão do sistema?',
    answer:
      'Depende do escopo. Uma primeira versão útil — login, cadastros centrais e o fluxo principal — costuma sair em semanas, não em meses de caixa-preta. Você acompanha e valida cada etapa.',
  },
  {
    question: 'O código e os dados do sistema ficam com a minha empresa?',
    answer:
      'Sim. O sistema é da sua empresa: regras, dados e evolução. Combinamos hospedagem, backup e suporte contínuo depois do go-live.',
  },
];

const PARANA = { '@type': 'State', name: 'Paraná', addressCountry: 'BR' };

function cityInParana(name) {
  return { '@type': 'City', name, containedInPlace: PARANA };
}

export function buildFaqJsonLd(faqItems) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };
}

export function buildLocalBusinessJsonLd() {
  const biz = LOCAL_BUSINESS;
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': `${biz.url}/#localbusiness`,
    name: biz.name,
    legalName: biz.legalName,
    url: biz.url,
    logo: biz.logo,
    image: biz.logo,
    telephone: biz.telephone,
    email: biz.email,
    taxID: biz.taxID,
    priceRange: '$$',
    hasMap: biz.map,
    areaServed: [
      cityInParana('Palotina'),
      cityInParana('Toledo'),
      cityInParana('Cascavel'),
      cityInParana('Maripá'),
      cityInParana('Assis Chateaubriand'),
      PARANA,
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: biz.streetAddress,
      addressLocality: biz.addressLocality,
      addressRegion: biz.addressRegion,
      postalCode: biz.postalCode,
      addressCountry: biz.addressCountry,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: biz.latitude,
      longitude: biz.longitude,
    },
    sameAs: biz.sameAs,
    knowsAbout: [
      'desenvolvimento de sistema em Palotina',
      'software sob medida',
      'aplicativos Android e iOS',
      'integração com ERP',
      'força de vendas',
    ],
  };
}

export function buildCitySystemJsonLd(meta, cityName, faqItems = []) {
  const url = `https://innovanow.com.br${meta.canonicalPath}`;
  const schemas = [
    buildLocalBusinessJsonLd(),
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: meta.title,
      description: meta.description,
      url,
      inLanguage: 'pt-BR',
      about: {
        '@type': 'Service',
        name: meta.heroTitle,
        serviceType: 'Desenvolvimento de sistemas e aplicativos sob medida',
        provider: { '@id': `${LOCAL_BUSINESS.url}/#localbusiness` },
        areaServed: cityInParana(cityName),
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://innovanow.com.br/' },
        { '@type': 'ListItem', position: 2, name: meta.heroTitle, item: url },
      ],
    },
  ];

  if (faqItems.length) {
    schemas.push(buildFaqJsonLd(faqItems));
  }

  return schemas;
}

export function buildCitySiteJsonLd(meta, cityName) {
  const url = `https://innovanow.com.br${meta.canonicalPath}`;
  return [
    buildLocalBusinessJsonLd(),
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: meta.title,
      description: meta.description,
      url,
      inLanguage: 'pt-BR',
      about: {
        '@type': 'Service',
        name: meta.heroTitle,
        serviceType: 'Criação de sites',
        provider: { '@id': `${LOCAL_BUSINESS.url}/#localbusiness` },
        areaServed: cityInParana(cityName),
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://innovanow.com.br/' },
        { '@type': 'ListItem', position: 2, name: meta.heroTitle, item: url },
      ],
    },
  ];
}

export function buildContentPageJsonLd({ path, title, description, name }) {
  const url = `https://innovanow.com.br${path}`;
  return [
    buildLocalBusinessJsonLd(),
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: title,
      description,
      url,
      inLanguage: 'pt-BR',
      isPartOf: { '@type': 'WebSite', name: '(in)nova now', url: 'https://innovanow.com.br' },
      about: { '@id': `${LOCAL_BUSINESS.url}/#localbusiness` },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://innovanow.com.br/' },
        { '@type': 'ListItem', position: 2, name: name || title, item: url },
      ],
    },
  ];
}
